import tokensByType from './tokensByType';
import {combineReducers} from 'redux';
import * as ducks from '../ducks/index';
/* Ducks */
import checklistItems, {entity as checklistItem} from '../ducks/checklistItems';
import customer from '../ducks/customer';
import communicationPlans, {entity as communicationPlan} from '../ducks/communicationPlans';
import emailSnippets, {entity as emailSnippet} from '../ducks/emailSnippets';
import letterSnippets, {entity as letterSnippet} from '../ducks/letterSnippets';
import mailingLabelSnippets, {entity as mailingLabelSnippet} from '../ducks/mailingLabelSnippets';
import mmsSnippets, {entity as mmsSnippet} from '../ducks/mmsSnippets';
import mmsHistories, {entity as mmsHistory} from '../ducks/mmsHistories';
import users, {entity as user} from '../ducks/users';
import webSnippets, {entity as webSnippet} from '../ducks/webSnippets';
import widgetSnippets, {entity as widgetSnippet} from '../ducks/widgetSnippets';
import statuses, {entity as status} from '../ducks/statuses';
import bulkFileWorkflows, {entity as bulkFileWorkflow} from '../ducks/bulkFileWorkflows';
import bulkFilePages, {entity as bulkFilePage} from '../ducks/bulkFilePages';
import schoolYears, {entity as schoolYear} from '../ducks/schoolYears';
import userJobs, {entity as userJob} from '../ducks/schoolYears';

import mmsHistoryList from '../ducks/mmsHistoryList';
import mmsSettings from '../ducks/mmsSettings';
import bulkFileUploader from '../ducks/bulkFileUploader';
import communicationPlanEditor from '../ducks/communicationPlanEditor';
import EmailWorkflowDuck from '../ducks/EmailWorkflowDuck';
import UserEmailWorkflowDuck from '../ducks/UserEmailWorkflowDuck';
import MMSWorkflowDuck from "../ducks/MMSWorkflowDuck";

import {default as entityReducer} from  './sa-common-reducers/entities/index';
import {default as commonReducers} from './sa-common-reducers/index';


const emailWorkflow = new EmailWorkflowDuck().reducer();
const mmsWorkflow = new MMSWorkflowDuck().reducer();
const userEmailWorkflow = new UserEmailWorkflowDuck().reducer();

const duckEntityReducers = {};
const duckReducers = {};



Object.values(ducks).forEach(duck => {
  if (!duck.name) {
    console.error('duck is missing name', duck);
  }

  if (!duck.reducer) {
    console.error('duck is missing reducer', duck);
  }

  duckReducers[duck.name] = duck.reducer;

  if (duck.entityReducer) {
    duckEntityReducers[duck.name] = duck.entityReducer;
  }
});

const reducers = {
  ...commonReducers,

  // This is a no-op reducer that allows us to inject properties from the rails controller into redux state.
  // Add properties to ApplicationController#react_options[:state][:appConfig] to have them show up in state.
  appConfig: (state = {}) => state,

  entities: combineReducers({
    ...entityReducer,
    communicationPlans: communicationPlan.entityReducer,
    checklistItems: checklistItem.entityReducer,
    statuses: status.entityReducer,
    bulkFileWorkflows: bulkFileWorkflow.entityReducer,
    bulkFilePages: bulkFilePage.entityReducer,
    schoolYears: schoolYear.entityReducer,
    userJobs: userJob.entityReducer,
    emailSnippets: emailSnippet.entityReducer,
    letterSnippets: letterSnippet.entityReducer,
    mailingLabelSnippets: mailingLabelSnippet.entityReducer,
    mmsSnippets: mmsSnippet.entityReducer,
    mmsHistories: mmsHistory.entityReducer,
    webSnippets: webSnippet.entityReducer,
    widgetSnippets: widgetSnippet.entityReducer,
    ...duckEntityReducers
  }),

  customer,
  tokensByType,
  checklistItems,
  statuses,
  communicationPlans,
  emailSnippets,
  letterSnippets,
  mailingLabelSnippets,
  mmsHistories,
  mmsHistoryList,
  mmsSettings,
  mmsSnippets,
  mmsWorkflow,
  webSnippets,
  widgetSnippets,
  communicationPlanEditor,
  bulkFileUploader,
  bulkFileWorkflows,
  bulkFilePages,
  schoolYears,
  userJobs,
  emailWorkflow,
  userEmailWorkflow,
  ...duckReducers
};


export default reducers;
